import React from "react"
import { Skeleton } from "components/anti/skeleton/skeleton"

const NavbarSkeleton = ({ banner_type }) => {
  return (
    <div className={`desktop-menu d-none d-lg-flex`}>
      <ul className="navbar-nav">
        {/* New link skeleton */}
        <li className="nav-item">
          <div className={`nav-link ${banner_type === "dark" && "text-light"}`}>
            <Skeleton
              width="60px"
              height="20px"
              className="skeleton-nav-link"
            />
          </div>
        </li>

        {/* Sale link skeleton */}
        <li className="nav-item">
          <div
            className={`nav-link text-danger ${
              banner_type === "dark" && "text-light"
            }`}
          >
            <Skeleton
              width="40px"
              height="20px"
              className="skeleton-nav-link"
            />
          </div>
        </li>

        {/* Categories skeleton - show 3-4 category items */}
        {Array.from({ length: 4 }).map((_, index) => (
          <li className="nav-item" key={index}>
            <div
              className={`nav-link ${banner_type === "dark" && "text-light"}`}
            >
              <Skeleton
                width={`${80 + index * 10}px`}
                height="20px"
                className="skeleton-nav-link"
              />
            </div>
          </li>
        ))}
      </ul>

      {/* Search skeleton */}
      <div className="col-right">
        <li className="nav-item nav-search">
          <div className="form-search">
            <Skeleton width="200px" height="40px" className="skeleton-search" />
          </div>
        </li>
      </div>
    </div>
  )
}

export default NavbarSkeleton
